import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { QUOTE_PRICING_FRAGMENT } from 'graphql/fragments/quote-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';
import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_POSITION_QUANTITY_MUTATION = gql`
  mutation setLineQuantity(
    $documentVersion: DocumentVersionInput!
    $lineId: String!
    $quantity: Decimal!,
    $withPricing: Boolean = true,
    $withQuotePricing: Boolean = true
  ) {
    quotes {
      modify(documentVersion: $documentVersion) {
        line(id: $lineId) {
          setQuantity(quantity: $quantity) {
            documentId
            revision
            status
            snkModifier {
              profile {
                firstName
                lastName
              }
            }
            lines {
              id
              isSubLine
              parentLine {
                id
              }
              customProperties {
                stringValue
                key
              }
              ... on ProductLine {
                quantity {
                  value
                }
                product {
                  isConfigurable
                }
              }
              ... on CustomLine {
                quantity {
                  value
                }
                article {
                  id
                }
              }
              ...ProductLinePricingFragment @include(if: $withPricing)
              ...CustomLinePricingFragment @include(if: $withPricing)
            }
            ...QuotePricingFragment @include(if: $withQuotePricing)
            ...QuotePricingStateFragment @skip(if: $withQuotePricing)
          }
        }
      }
    }
  }
  ${PRODUCT_LINE_PRICING_FRAGMENT}
  ${CUSTOM_LINE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_FRAGMENT}
  ${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdatePositionQuantityMutation extends Mutation<RootMutation> {
  document = UPDATE_POSITION_QUANTITY_MUTATION;
}
